// extracted by mini-css-extract-plugin
export default {"collection-list":"CollectionsList_collection-list__hL38s","collectionList":"CollectionsList_collection-list__hL38s"};